import React, { useState } from "react";
import { Box, Button, Flex, Link, Text } from "@chakra-ui/core";
import QuiklyyLogo from "../../../static/assets/icons/quiklyy.png";
import "./NavBar.scss";
import { useHistory } from "react-router-dom";

const NavBarLink = ({ linkTo, value }) => {
  return (
    <a href={linkTo}>
      <Text mt={{ base: 4, md: 0 }} mr={6} fontSize="sm" marginX="0.75em">
        {value}
      </Text>
    </a>
  );
};

function NavBar() {
  const history = useHistory();
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);
  const NavBarArray = [
    "Home",
    "Clients",
    "Pricing",
    "About Us",
    "Blog",
    "Contact",
  ];
  return (
    <Flex
      boxShadow="lg"
      wrap={{ lg: "nowrap", base: "wrap" }}
      as="nav"
      alignItems="center"
      className="navbar"
      color="black"
      padding="0.75em"
    >
      {/* <Flex align="center">
                <img width="30" height="30" alt="Logo" src={Logo} />
                <Text fontSize="lg">Recruitify</Text>
            </Flex> */}
      <Box>
        <Link href="/">
          <img width="100" height="200" src={QuiklyyLogo} alt="logo" />
        </Link>
      </Box>

      <Box display={{ base: "block", md: "none" }} onClick={handleToggle}>
        <svg
          fill="teal"
          width="20px"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </Box>
      <Box
        justifyItems="center"
        display={{
          xs: show ? "block" : "none",
          sm: show ? "block" : "none",
          md: "flex",
        }}
        width={{ sm: "full", md: "auto" }}
        alignItems="center"
      >
        {NavBarArray.map((each) => (
          <NavBarLink
            key={each}
            linkTo={"#" + each.toLowerCase()}
            value={each}
          />
        ))}
        <Button onClick={() => history.push('/auth')} mt={{ base: 4, md: 0 }} ml={3} size="xs" variantColor="green">
          Login / SignUp
        </Button>
      </Box>
    </Flex>
  );
}

export default NavBar;
